import { Link } from 'react-router-dom'

export default function ServiceCard({ icon, title, price, priceNote, description, to, highlight = false, badge }) {
  return (
    <div
      className={`relative bg-white p-7 rounded-xl flex flex-col h-full ${
        highlight
          ? 'border-2 border-ecbc-sky shadow-md bg-ecbc-navy/[0.05]'
          : 'border border-gray-100 shadow-sm'
      }`}
    >
      {badge && (
        <span className="absolute -top-3 left-6 bg-ecbc-sky text-ecbc-navy text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
          {badge}
        </span>
      )}
      <div className="flex-1">
        <div className="w-12 h-12 rounded-lg bg-ecbc-navy/10 flex items-center justify-center mb-5 text-ecbc-navy">
          {icon}
        </div>
        <h3 className="font-bold text-ecbc-navy text-lg mb-1">{title}</h3>
        {price && <p className={`text-sm font-semibold text-ecbc-gold-text ${priceNote ? 'mb-0.5' : 'mb-3'}`}>{price}</p>}
        {priceNote && <p className="text-xs text-gray-500 mb-3">{priceNote}</p>}
        <p className="text-gray-500 text-sm leading-relaxed mb-5">{description}</p>
      </div>
      <Link
        to={to}
        className="text-sm font-semibold text-ecbc-navy hover:text-ecbc-navy/70 transition-colors inline-flex items-center gap-1"
      >
        Explore {title}
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </Link>
    </div>
  )
}
